const s = {
  topLevels: document.getElementsByClassName('menu-item-has-children'),
}

function init() {
  if (s.topLevels.length > 0) {
    bindEvents();
    openSearch();
    
  }

  // need to add class to body when mega menu open
  // Select all li elements with the class .o-menu__subnav-mega
  var megaMenuItems = document.querySelectorAll('li.o-menu__subnav-mega');

  // Loop through each li element and add event listeners
  megaMenuItems.forEach(function(item) {
    item.addEventListener('mouseenter', function() {
      // Add the "mega-open" class to the <body> when hovering over any li
      document.body.classList.add('mega-open');
    });

    item.addEventListener('mouseleave', function() {
      // Remove the "mega-open" class from the <body> when the hover ends
      document.body.classList.remove('mega-open');
    });
  });

  // making any megamenu dropdown with grandchildren links 3 columns
  jQuery(".mega-grandchildren").closest("ul[data-fartlek='0']").attr("data-fartlek", "3");

  // using js to target last mega menu item bc pure css was not being helpful
  const parentDiv = document.getElementById('Menumain');
  const megaItems = parentDiv.querySelectorAll('.o-menu__subnav-mega');
  if (megaItems.length > 0) {
      const lastMegaItem = megaItems[megaItems.length - 1];
      const newElement = document.createElement('li');
      lastMegaItem.insertAdjacentElement('afterend', newElement);
      newElement.style.flexGrow = '1';
  }

  // gtranslate icon behavior
  document.querySelectorAll(".gtranslate-icon").forEach((element) => {
    element.addEventListener("click", function(event) {
      event.preventDefault(); // Prevent the default link behavior
      var widget = document.getElementById('gtranslate-widget');
      widget.style.display = widget.style.display === 'none' ? 'block' : 'none';
    });
  });

  // move gtranslate widget between mobile and desktop (two instances would not be good idea)
  const translateWidget = document.getElementById("gtranslate-widget");
  const desktopSack = document.getElementById("languageWidgetDesktopSack");
  const mobileSack = document.getElementById("mobileTranslateWidgetSack");

  function moveWidget() {
      if (window.innerWidth < 1216) {
        mobileSack.appendChild(translateWidget); // Move to mobile menu
      } else {
        desktopSack.appendChild(translateWidget); // Move back to desktop menu
      }
  }

  moveWidget(); // Run on page load
  window.addEventListener("resize", moveWidget); // Run on window resize

  // Header scroll
    let lastScrollTop = 0;
    const header = document.getElementById('header');
    let utilityNavHeight, mainMenuHeight;

    // Function to recalculate heights
    function updateHeaderHeights() {
        utilityNavHeight = header.querySelector('.o-header__utility-menu-group').offsetHeight;
        mainMenuHeight = header.querySelector('.o-header__main-menu-group').offsetHeight;
    }

    // Run on page load
    updateHeaderHeights();

    // Recalculate heights on window resize
    window.addEventListener('resize', updateHeaderHeights);

    window.addEventListener('scroll', function () {
        const scrollTop = window.scrollY;

        if ((scrollTop > lastScrollTop) && (!document.getElementById("searchButton").classList.contains("search-revealed"))) { // do not run if search box is open
            // Scrolling down
            if (window.innerWidth > 1215) {
                header.style.transform = `translateY(-${utilityNavHeight + mainMenuHeight}px)`;
            } else {
                header.style.transform = `translateY(-${header.offsetHeight}px)`;
            }
        } else {
            // Scrolling up
            if (scrollTop + window.innerHeight < document.body.offsetHeight) {
                header.style.transform = 'translateY(0)';
            }
        }

        lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // For Mobile or negative scrolling
    });

    // Show full header at the top of the page
    window.addEventListener('scroll', function () {
        if (window.scrollY === 0) {
            header.style.transform = 'translateY(0)';
        }
    });

    // anchor links
    document.querySelectorAll('main a[href^="#"]:not(.em-booking *)').forEach(anchor => {
      anchor.addEventListener('click', function (e) {
        e.preventDefault();

        const target = document.querySelector(this.getAttribute('href'));

        if (target) {
          target.scrollIntoView({
            behavior: 'smooth'
          });
        }
      });
    });

}

function bindEvents() {
  for (let index = 0; index < s.topLevels.length; index++) {
    const element = s.topLevels[index];
    element.addEventListener('focusin', function() {openMenu(element)});
    element.addEventListener('focusout', function() {closeMenu(element)});
  }
}

function openMenu(element) {
  element.setAttribute('aria-expanded', 'true');
}

function closeMenu(element) {
  element.setAttribute('aria-expanded', 'false');
}

function openSearch() {
  document.getElementById('searchButtonIcon').addEventListener('click', function(e) {
    e.preventDefault();
    if (!this.parentNode.classList.contains('search-revealed')) {
      this.parentNode.classList.add('search-revealed');
    }
  });
  document.getElementById('closeSearch').addEventListener('click', function(e) {
    e.preventDefault();
    document.getElementById('searchButton').classList.remove('search-revealed');
    document.getElementById("search").value = "";
  });
  document.getElementById('searchButtonGo').addEventListener('click', function(e) {
    e.preventDefault();
    document.getElementById('searchForm').submit();
  });
  
}

export { init as default }
